import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

// Admin-only: the payments Set tuition would offer for these choices. Saves nothing.
// On a signed agreement that's a change: the payments that stay (kept) and the new ones.
const TuitionTermsPreview = graphql.persisted(
  "TuitionTermsPreview",
  graphql(`
    query TuitionTermsPreview($itemId: ID!, $paymentOptionKey: String!, $aidCents: Int!, $amounts: [Int!], $offAutoPay: [Int!]) {
      tuitionTermsPreview(itemId: $itemId, paymentOptionKey: $paymentOptionKey, aidCents: $aidCents, amounts: $amounts, offAutoPay: $offAutoPay) {
        totalCents
        discountCents
        installments { dueOn amountCents autoPay }
        kept { dueOn amountCents status }
        error
      }
    }
  `)
);

export { TuitionTermsPreview };

export interface TuitionTermsChoices {
  paymentOptionKey: string;
  aidCents: number;
  amounts: number[] | null;
  offAutoPay: number[];
}

export function useTuitionTermsPreview(itemId: string, choices: TuitionTermsChoices | null) {
  return useQuery(TuitionTermsPreview, {
    variables: {
      itemId,
      paymentOptionKey: choices?.paymentOptionKey ?? '',
      aidCents: choices?.aidCents ?? 0,
      amounts: choices?.amounts ?? null,
      offAutoPay: choices?.offAutoPay ?? [],
    },
    skip: !choices,
    fetchPolicy: 'network-only',
  });
}
